/**
 * Created by JMC on 25/11/19.
 */

export class EcmsEntry {
  ecms_id: number;
  ecms_status_id: number;
  ecms_status_text: string;
  mprn: string;
  hub_batch: number;
  ei_batch: number;
  serial_no: number;
  post_code: string;
  end_time: Date;
  comment: string;
  date_sent: Date;
  last_seen: Date;
  company_name: string;
  job_id: string;
  first_name: string;
  address_line_1: string;
  address_line_2: string;
  contact_mobile: string;
}
